/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React, { useState, createContext } from 'react';
import { DragDropContext } from '@hello-pangea/dnd';
export var EuiDragDropContextContext = /*#__PURE__*/createContext({
  isDraggingType: null
});
export var EuiDragDropContext = ({
  onBeforeDragStart,
  onDragStart,
  onDragUpdate,
  onDragEnd,
  children,
  ...rest
}) => {
  const [isDraggingType, setIsDraggingType] = useState(null);
  const euiOnDragStart = (start, provided) => {
    setIsDraggingType(start.type);
    if (onDragStart) {
      onDragStart(start, provided);
    }
  };
  const euiOnDragEnd = (result, provided) => {
    setIsDraggingType(null);
    if (onDragEnd) {
      onDragEnd(result, provided);
    }
  };
  return <DragDropContext onBeforeDragStart={onBeforeDragStart} onDragStart={euiOnDragStart} onDragUpdate={onDragUpdate} onDragEnd={euiOnDragEnd} {...rest}>
      <EuiDragDropContextContext.Provider value={{
      isDraggingType
    }}>
        {children}
      </EuiDragDropContextContext.Provider>
    </DragDropContext>;
};
try {
  EuiDragDropContext.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src/components/drag_and_drop/drag_drop_context.tsx',
    description: '',
    displayName: 'EuiDragDropContext',
    methods: [],
    props: {
      dragHandleUsageInstructions: {
        defaultValue: null,
        description: '',
        name: 'dragHandleUsageInstructions',
        parent: {
          fileName: 'eui/node_modules/@hello-pangea/dnd/dist/dnd.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'eui/node_modules/@hello-pangea/dnd/dist/dnd.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      enableDefaultSensors: {
        defaultValue: null,
        description: '',
        name: 'enableDefaultSensors',
        parent: {
          fileName: 'eui/node_modules/@hello-pangea/dnd/dist/dnd.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'eui/node_modules/@hello-pangea/dnd/dist/dnd.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      nonce: {
        defaultValue: null,
        description: '',
        name: 'nonce',
        parent: {
          fileName: 'eui/node_modules/@hello-pangea/dnd/dist/dnd.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'eui/node_modules/@hello-pangea/dnd/dist/dnd.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      sensors: {
        defaultValue: null,
        description: '',
        name: 'sensors',
        parent: {
          fileName: 'eui/node_modules/@hello-pangea/dnd/dist/dnd.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'eui/node_modules/@hello-pangea/dnd/dist/dnd.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'Sensor[]'
        }
      },
      autoScrollerOptions: {
        defaultValue: null,
        description: 'Customize auto scroller',
        name: 'autoScrollerOptions',
        parent: {
          fileName: 'eui/node_modules/@hello-pangea/dnd/dist/dnd.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'eui/node_modules/@hello-pangea/dnd/dist/dnd.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'RecursivePartial<AutoScrollerOptions>'
        }
      }
    },
    extendedInterfaces: ['Responders']
  };
} catch (e) {}